import { render, staticRenderFns } from "./MyActiveTownNotifications.vue?vue&type=template&id=053f7538"
import script from "./MyActiveTownNotifications.vue?vue&type=script&lang=js"
export * from "./MyActiveTownNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports